import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'dual-screen', 'DualScreen', [["path",{"d":"M5 4l8 3v15l-8 -3l0 -15","key":"svg-0"}],["path",{"d":"M13 19h6v-15h-14","key":"svg-1"}]]);